"use client";

import React from "react";
import DatePicker from "react-datepicker";
import { Input } from "../input";
import { Label } from "../label";
import { cn } from "@/lib/utils";

interface TimePickerFieldProps {
  label?: string;
  selected: Date | null;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  timeFormat?: string;
  timeIntervals?: number;
  minTime?: Date;
  maxTime?: Date;
  error?: string;
}

export const TimePickerField = ({
  label,
  selected,
  onChange,
  placeholder = "Select time",
  className,
  disabled = false,
  timeFormat = "HH:mm",
  timeIntervals = 15,
  minTime,
  maxTime,
  error,
}: TimePickerFieldProps) => {
  return (
    <div className={cn("space-y-2", className)}>
      {label && (
        <Label className={cn(error && "text-destructive")}>{label}</Label>
      )}
      <div className="relative">
        <DatePicker
          selected={selected}
          onChange={onChange}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={timeIntervals}
          timeCaption="Time"
          dateFormat={timeFormat}
          placeholderText={placeholder}
          disabled={disabled}
          minTime={minTime}
          maxTime={maxTime}
          customInput={
            <Input
              className={cn(
                error && "border-destructive focus-visible:ring-destructive",
              )}
            />
          }
          popperClassName="z-[10001]"
          popperPlacement="bottom-start"
        />
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};
